import { Immutable } from '@play-co/replicant';
import { getPetSpeciesById } from '../pet/pet.ruleset';

// How many records to keep
export const maxHistoryRecords = 1000;

// Detect species type
const species = Array.from(
  new Set(getPetSpeciesById('control').map(({ id }) => id)),
);
type SpeciesType = (typeof species)[number];

// Detect available stages type
export const stage = Array.from(
  new Set(getPetSpeciesById('control').map(({ stage }) => stage)),
);
type StageType = (typeof stage)[number];

// Evolution type
type Evolutions = { species: SpeciesType; stage: StageType; timestamp: number };

// Available history records
export type HistoryDeathRecord = {
  type: 'death';
  species: SpeciesType;
  name: string;
  age: number;
  evolutions: Evolutions[];
  timestamp: number;
};

export type HistoryFriendDuoRecord = {
  species: SpeciesType;
  name: string;
  age: number;
};

export type HistoryDuoRecord = {
  type: 'duo';
  species: SpeciesType;
  name: string;
  age: number;
  evolutions: Evolutions[];
  friendID: string;
  timestamp: number;
  friend: HistoryFriendDuoRecord;
};

export type HistoryRecord = Immutable<HistoryDeathRecord | HistoryDuoRecord>;
